/** @flow */

export const accountMessages = {
  en: {
    PASSWORD_UPDATED_SUCCESS: "Password was successfully updated",
  },
};

export default {
  en: {
    // Common
    LOGIN: "Login",
    WELCOME_TO_MYFIRSTCARE: "Welcome to GoodShapeCentral!",
    WELCOME_TO_MYFIRSTCARE_DESCRIPTION:
      "Here you can access real-time absence reports, historic trends analysis and details of all of the actions required to help manage and reduce absence in your organisation.",
    // Service Unavailable
    SERVICE_UNAVAILABLE: "Service Unavailable",
    SERVICE_UNAVAILABLE_DESCRIPTION: `We're sorry but the GoodShapeCentral! portal is currently unavailable.
      We apologise for the inconvenience and can assure you that our team are working on the issue. 
      The service will be back online as soon as possible.`,
    // Login Form
    EMAIL_ADDRESS: "Email Address",
    PASSWORD: "Password",
    ENTER_PASSWORD: "Enter Password",
    FORGOT_YOUR_PASSWORD: "Forgot your password?",
    FORGOTTEN_YOUR_PASSWORD: "Forgotten Your Password?",
    REQUEST_PASSWORD_RESET: "Request Password Reset",
    FORGOTTEN_PASSWORD: "Forgotten password?",
    LOGIN_FAILED: `Login failed. 
    Please ensure that you are entering your correct login details and working on an authorised device.`,
    LOGIN_FAILED_WITH_ATTEMPT: `Login failed. {count} attempt remaining. 
    Please ensure that you are entering your correct login details and working on an authorised device.
    If this attempt is unsuccessful the account will be locked and will require assistance to unlock by admin.`,
    SESSION_HAS_EXPIRED: "Your session has expired. Please log back in below.",
    // Account Locked
    ACCOUNT_LOCKED: "Account Locked",
    ACCOUNT_LOCKED_DESCRIPTION: `Because of 4 failed login attempts your GoodShapeCentral! account has been locked.
      To regain access to the system, please use the Request Account Unlock option below and follow the instructions.`,
    REQUEST_ACCOUNT_UNLOCK: "Request Account Unlock",
    BACK_TO_LOGIN: "Back to Login",
    // Reset Password
    RESET_PASSWORD: "Reset Password",
    RESET_PASSWORD_DESCRIPTION:
      "Please submit your email address below and you will receive a link to reset your password.",
    REQUEST_RESET_LINK: "Request Reset Link",
    NO_ACCOUNT_FOUND_FOR_THIS_EMAIL:
      "No account found for this email address. Please make sure the specified address is correct.",
    // Expired Password
    EXPIRED_PASSWORD: "Expired Password",
    EXPIRED_PASSWORD_DESCRIPTION:
      "Your current password has expired. Please set a new password before logging in.",
    SET_NEW_PASSWORD: "Set New Password",
    // Register Form
    REGISTER: "Register",
    CHOOSE_PASSWORD: "Choose Password",
    CONFIRM_PASSWORD: "Confirm Password",
    CREATE_ACCOUNT: "Create Account",
    I_HAVE_READ_AND_UNDERSTAND_THE_TERMS_OF_USE: "I have read and understand the {Terms of Use}",
    TERMS_OF_USE: "Terms of Use",
    // Terms Of Use Modal
    ACCEPTANCE_OF_TERMS: "Acceptance Of Terms",
    ACCEPTANCE_OF_TERMS_DESCRIPTION:
      'Welcome to the GoodShape Ltd Absence Management Portal. GoodShape Ltd provides access to this portal, subject to the following Terms of Service ("TOS"), which may be updated by GoodShape Ltd from time to time.',
    DESCRIPTION_OF_SERVICE: "Description of Service",
    DESCRIPTION_OF_SERVICE_DESCRIPTION:
      "GoodShape Ltd currently provides users with access to a selection of absence data, including employee absence histories, department absence trends and notification contact details such as telephone numbers and e-mail addresses. In order to use the portal, you must obtain access to the World Wide Web, either directly or through devices that access web-based content, and pay any service and/or telephony fees associated with such access. In addition, you must provide all equipment necessary to make such connection to the World Wide Web, including a computer and modem or other access device.",
    MEMBER_ACCOUNT_CREDENTIALS_AND_SECURITY: "Member Account Credentials and Security",
    MEMBER_ACCOUNT_CREDENTIALS_AND_SECURITY_DESCRIPTION:
      "You are responsible for maintaining the confidentiality of any account details used to access your account on the portal, and you are fully responsible for all activities that occur under your account. You agree to notify GoodShape of any unauthorised use of your password or account, and ensure that you logout of your account at the end of each session.",
    NO_RESALE_OF_SERVICE: "No Resale of Service",
    NO_RESALE_OF_SERVICE_DESCRIPTION:
      "You agree not to reproduce, duplicate, copy, sell, resell or exploit for any commercial purposes, any portion of the portal, use of the portal, or access to the portal.",
    LINKS: "Links",
    LINKS_DESCRIPTION:
      "The portal may provide links to other World Wide Web sites or resources. Because GoodShape Ltd has no control over such sites and resources, you acknowledge and agree that GoodShape Ltd is not responsible for the availability of such external sites or resources, and does not endorse and is not responsible or liable for any Content, advertising, products, or other materials on or available from such sites or resources. You further acknowledge and agree that GoodShape Ltd shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such Content, goods or services available on or through any such site or resource.",
    FIRSTCARE_LTDS_PROPRIETARY_RIGHTS: "GoodShape LTD's Proprietary Rights",
    FIRSTCARE_LTDS_PROPRIETARY_RIGHTS_DESCRIPTION:
      "You acknowledge and agree that the portal and any necessary software used in connection with the Portal contain proprietary and confidential information that is protected by applicable intellectual property and other laws. Except as expressly authorised by GoodShape Ltd you agree not to modify, rent, lease, loan, sell, distribute or create derivative works based on the Service or the Software, in whole or in part.",
    TRADEMARK_INFORMATION: "Trademark Information",
    TRADEMARK_INFORMATION_DESCRIPTION:
      "GoodShape Ltd and the GoodShape Ltd logo, are trademarks of GoodShape Ltd. Without GoodShape Ltd's prior permission, you agree not to display or use in any manner, the GoodShape Ltd logos or names.",
    GENERAL_INFORMATION: "General Information",
    GENERAL_INFORMATION_DESCRIPTION:
      "Usage of the GoodShapeCentral! portal and any systems belonging to GoodShape Ltd is subject to the terms and conditions of service agreed between your employer and GoodShape Ltd. In the event of any queries regarding these terms please refer to your employer. ",
    // Forgotten Password
    CONFIRM_EMAIL: "Please confirm your email address",
    ENTER_EMAIL: "Enter Email Address",
    RETURN_TO_LOGIN: "Return To Login",
    // Welcome Message
    WELCOME_HEADING: "Welcome to GoodShapeCentral!",
    WELCOME_TEXT:
      "Here you can access real-time absence reports, historic trends analysis and details of all of the actions required to help manage and reduce absence in your organisation.",
    LOGOUT: "Log Out",

    // Roles & Permission Claims
    THIS_SECTION: "this section",
    UNAUTHORISED_ACCESS: "Unauthorised Access",
    YOU_DO_NOT_HAVE_ACCESS_TO: "You do not have access to {section name}.",
    UNAUTHORISED_ACCESS_DESCRIPTION:
      "If you feel that you should be able to access this page please contact a member of your HR team.",
    CONTACT_OUR_CENTER: "Need help? Contact our Customer Service team.",
    IMPERSONATION_NOTIFICATION: "You are logged in as {name}",
  },
};
